import requestProvider from "./axiosHandler";

const getAllStock = () => {

    return requestProvider
        .get('/stock/get-all')
}

const createStock = (list) => {

    return requestProvider
        .post('/stock', {
            name: list.name,
            code: list.code,
            description: list.description,
            price: list.price,
            currency: list.currency,
            unit: list.unit,
            criticalThresdhold: list.criticalThresdhold,
            firmStockCode: list.firmStockCode,
            brand: {
                id: list.brandId
            },
            category: list.categoryId ? {id:list.categoryId} : null,
        })
}

const updateStockFromRecipe = (list) => {

    return requestProvider
        .put('/stock', {
            id: list.id,
            name: list.name,
            code: list.code,
            description: list.description,
            brand: {
                id: list.brand.id
            },
            category: list.categoryId ? {id:list.categoryId} : null,
            price: list.price,
            currency: list.currency,
            unit: list.unit,
            firmStockCode: list.firmStockCode,
            criticalThresdhold: list.criticalThresdhold
        })
}

const updateStock = (list) => {
    return requestProvider
        .put('/stock', {
            id: list.id,
            name: list.name,
            code: list.code,
            description: list.description,
            brand: {
                id: list.brandId
            },
            category: list.categoryId ? {id:list.categoryId} : null,
            price: list.price,
            currency: list.currency,
            unit: list.unit,
            firmStockCode: list.firmStockCode,
            criticalThresdhold: list.criticalThresdhold
        })
}

const deleteStock = (id) => {

    return requestProvider
        .delete(`/stock/${id}`)
}

const getStockById = (id) => {

    return requestProvider
        .get(`/stock/${id}`)
}

const stockUploadExcel = (file) => {
    return requestProvider
        .post('/stock/import-stocks', {file: file})
}

const getAllWithInventories = () => {
    return requestProvider
        .get('/stock/get-with-inventories')
}

const getWithWarehouseInventories = () => {
    return requestProvider
        .get('/stock/get-all-warehouses')
}

const filterStocks = (list) => {
    return requestProvider
        .post('/stock/filter', list)
}

const getAllStockCodes = () => {
    return requestProvider
        .get('stock/get-codes')
}

const getStocksAsSelect = () => {
    return requestProvider
        .get('stock/select');
}

const getStocksWithPage = (list) => {
    return requestProvider
        .post('stock/page-filter', list);
}

export {
    filterStocks,
    getAllStockCodes,
    getAllWithInventories,
    getAllStock,
    createStock,
    updateStock,
    deleteStock,
    getStockById,
    updateStockFromRecipe,
    stockUploadExcel,
    getWithWarehouseInventories,
    getStocksAsSelect,
    getStocksWithPage
}